/* Pookie's Pal - boot scheduling correction for pp-fixes.js.
   Added 2026-08-23.

   THE PROBLEM

   boot() in assets/pp-fixes.js runs:

     var wait = window.setInterval(function () {
       attempts += 1;
       var filtersReady = installFilters();
       var sortReady = installSort();
       ...
       if ((filtersReady && sortReady) || attempts > 30) { ... }
     }, 100);

   That is up to THREE SECONDS of re-running installFilters(), installSort()
   and applyFilters() after first paint. The collection toolbar is
   server-rendered, so the first attempt succeeds on a normal load and every
   later tick is pure visible rework. It is the single largest contributor to
   the 1-2 seconds of old layout on a collection page.

   WHY IT IS PATCHED HERE RATHER THAN IN pp-fixes.js

   pp-fixes.js is 30KB and could not be rewritten in place through this
   connection. The corrected pp-fixes.js exists as a file to upload; once it
   is in, this shim becomes a no-op because the interval it looks for no
   longer exists. Leaving it in place after that is harmless.

   HOW IT IS SCOPED

   Deliberately narrow, because wrapping a global timer is a blunt tool:

     - only on /collections/all, the only path where boot() polls
     - only for delay === 100, the exact delay boot() uses
     - only until window load, then the native function is restored
     - the callback still runs, four times rather than thirty

   Nothing is cancelled outright and no other page is affected. An earlier
   draft also wrapped setTimeout to collapse the promo countdown's
   250/800/1600ms re-inserts; that was removed because pp-fixes.js schedules
   the delivery-box sync on [300, 900, 1600] through the same function, and
   a global setTimeout wrapper is too coarse to tell them apart safely. The
   promo CLS fix is in the corrected pp-fixes.js instead. */

(function () {
  if (window.__ppBootPatched) return;
  if (window.location.pathname.replace(/\/$/, '') !== '/collections/all') return;
  window.__ppBootPatched = true;

  var nativeSetInterval = window.setInterval;

  window.setInterval = function (fn, delay) {
    if (delay === 100 && typeof fn === 'function') {
      var ticks = 0;
      var id = nativeSetInterval.call(window, function () {
        ticks += 1;
        try { fn(); } catch (e) {}
        if (ticks >= 4) window.clearInterval(id);
      }, 100);
      return id;
    }
    return nativeSetInterval.apply(window, arguments);
  };

  function restore() {
    window.setInterval = nativeSetInterval;
  }

  if (document.readyState === 'complete') {
    nativeSetInterval.call(window, function () {}, 100000);
    restore();
  } else {
    window.addEventListener('load', restore);
  }
})();
